import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import {
	CreateEmploymentRecordDto,
	EmploymentRecordRes,
	UpdateEmploymentRecordDto,
} from '@dealstack/shared/lib/generated';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';

export const createPersonEmploymentRecordRequest = async ({
	personId,
	body,
}: {
	personId: string;
	body: CreateEmploymentRecordDto;
}): Promise<EmploymentRecordRes | null> => {
	return await makeRequest<ApiV1.Response<EmploymentRecordRes>>({
		endpoint: formatUnicorn(API_PATHS.PERSONS_PERSONID_EMPLOYMENT_RECORDS_POST, {
			personId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	}).then((response) => response.payload ?? null);
};

export const updatePersonEmploymentRecordRequest = async ({
	employmentRecordId,
	body,
}: {
	employmentRecordId: string;
	body: UpdateEmploymentRecordDto;
}): Promise<EmploymentRecordRes | null> => {
	return await makeRequest<ApiV1.Response<EmploymentRecordRes>>({
		endpoint: formatUnicorn(API_PATHS.EMPLOYMENT_RECORDS_EMPLOYMENTRECORDID_PUT, {
			employmentRecordId,
		}),
		method: HTTP_METHOD.PUT,
		body: JSON.stringify(body),
	}).then((response) => response.payload ?? null);
};

export const deletePersonEmploymentRecordRequest = async ({
	employmentRecordId,
}: {
	employmentRecordId: string;
}): Promise<EmploymentRecordRes | null> => {
	return await makeRequest<ApiV1.Response<EmploymentRecordRes>>({
		endpoint: formatUnicorn(API_PATHS.EMPLOYMENT_RECORDS_EMPLOYMENTRECORDID_DELETE, {
			employmentRecordId,
		}),
		method: HTTP_METHOD.DELETE,
	}).then((response) => response.payload ?? null);
};
